var $ = require("jquery");

var scroll;
var hideAt = 136;

(function () {
    $.get("/images/icons/_Sprite.svg", function (data) {
        var div = document.createElement("div");
        div.innerHTML = new XMLSerializer().serializeToString(data.documentElement);
        document.body.insertBefore(div, document.body.childNodes[0]);
    });

    if ($(window).scrollTop() > 10) {
        onScroll();
    }

    $(document).on('scroll', onScroll);

    function onScroll() {
        var currentScroll = $(window).scrollTop();

        if (scroll && currentScroll < scroll) {
            $(".Header").css('top', 0);
        }
        else if (scroll && currentScroll > hideAt) {
            $(".Header").css('top', -$('.Header').outerHeight());
        }

        scroll = currentScroll;
    }
})();

